// Core runtime constants (lang, booleans, action keys, status).
// Split from constants.js — edit here, not the barrel.

import { DRAFT_VER, PRODUCT } from './internal'

export const core = {
BOOLEAN: {
        TRUE: true,
        FALSE: false,
    },
ACTION_KEY: {
        PRODUCT: {
            CAT: 'CAT',
            REDEEM: 'REDEEM',
            REDEEM_INFO: 'REDEEM_INFO',
            PRODUCT_INFO: 'PRODUCT_INFO',
            DRAFT: 'DRAFT',
            PRODUCT: 'PRODUCT',
            LOT_INVENTORY: 'LOT_INVENTORY',
            LOT_INVENTORY_SUB: 'LOT_INVENTORY_SUB',
            LEFT_IMAGE: 'LEFT_IMAGE'
        },
        SELECT_TAG: {
            DRAFT: 'DRAFT',
        },
    },
LANG: {
        TC: 'TC',
        EN: 'EN',
        SC: 'SC',
    },
DRAFT_VER: DRAFT_VER,
NOTIFIER: {
        EMAIL: 'EMAIL',
        SMS: 'SMS',
        WHATSAPP: 'WHATSAPP',
    },
}

export const GET_ID_FROM_PAYLOAD = 'GET_ID_FROM_PAYLOAD'

export const STATUS = {
    active: 'A',
    pending: 'P',
    delete: 'D',
}
